<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gdD0nF/tc-custom/9781504062152.jpg?1727649901535" alt="This image is the cover for the book Kwaidan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kwaidan
      </h1>
      <p class="bookDescription body article font2">
        <b>A classic book of ghost stories from one of the world’s leading nineteenth-century writers, the author of <i>In Ghostly Japan</i> and <i>Japanese Fairy Tales</i>.</b><br/>  <br/> Published just months before Lafcadio Hearn’s death in 1904, <i>Kwaidan</i> features several stories and a brief nonfiction study on insects: butterflies, mosquitoes, and ants. The tales included are reworkings of both written and oral Japanese traditions, including folk tales, legends, and superstitions.<br/>  <br/> “At age thirty-nine, Hearn travelled on a magazine assignment to Japan, and never came back. At a moment when that country, under Emperor Meiji, was weathering the shock and upheaval of forced economic modernization, Hearn fell deeply in love with the nation’s past. He wrote fourteen books on all manner of Japanese subjects but was especially infatuated with the customs and culture preserved in Japanese folktales—particularly the ghost-story genre known as <i>kaidan</i>. . . . He died in 1904, and, by the time his ‘Japanese tales’ were translated into Japanese, in the nineteen-twenties, the country’s transformation was so complete that Hearn was hailed as a kind of guardian of tradition; his <i>kaidan</i> collections are still part of the curriculum in many Japanese schools.” —<i>The New Yorker</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lafcadio Hearn
      </h2>
      
      <p class="authorDescription body article">Lafcadio Hearn, also called Koizumi Yakumo, was best known for his books about Japan. He wrote several collections of Japanese legends and ghost stories, including&#160;<I>Kwaidan: Stories and Studies of Strange Things</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75366d15